
import { Vue, Options } from "vue-class-component";
import DownloadTemplate from "../components/DownloadTemplateVertical.vue";
import UploadFile from "@/app/ui/components/upload-file/index.vue";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import {
  internationalTemplateUrl,
  permissionBulkBooking
} from "./modules/utils";
import SectionFilterClientV2 from "@/app/ui/views/shipment/booking/create-booking-v2/components/section-filter-client-v2.vue";
import { FlagsPermissionBulkBookingV2 } from "@/feature-flags/flags-bulk-booking-v2";
import { FlagsBcsBulkDownloadTemplate } from "@/feature-flags/flags-bulk-download-template";
import { AccountController } from "@/app/ui/controllers/AccountController";

@Options({
  components: {
    DownloadTemplate,
    UploadFile,
    SectionFilterClientV2
  }
})
export default class BulkBookingInternal extends Vue {
  activityNameBooking = "";
  resultUpload = false;
  resultErrorUpload = false;
  errorTitle = "";
  errorSubtitle = "";
  btnModalFailed = "";
  btnModalCancel = "";
  errorCode = 0;

  onChangeActivityName(value: string) {
    this.activityNameBooking = value;
  }

  goBack() {
    this.$router.push("/shipment/bulk/bulk-v2");
  }

  modalMessageSuccess(data: any) {
    return data?.success && data?.message === "uploading";
  }

  async _onAdd() {
    const resp = await BulkBookingController.uploadBulkBooking({
      activityName: this.form.activityName,
      archiveFile: this.form.archiveFile,
      posClientId:
        this.form.type === "client" && !this.utilsBulkBooking().permissionClient
          ? this.form.clientName.id
          : this.utilsBulkBooking().idAccount,
      posClientType: this.form.type === "client" ? "client" : "pos",
      templateFormat:
        this.form.type === "client" ? "client_template" : "genesis_template",
      versionType: "stt-v2"
    });

    if (this.modalMessageSuccess(resp)) {
      this.resultUpload = true;
      this.resetForm();
    } else {
      const statusCode = resp.response.data?.code;
      this.errorConditionModal(statusCode);
    }
    GTMCommonEvent("upload_bulk_booking_upload_clicked");
  }

  errorConditionModal(codeResp: number) {
    const statusCode = codeResp >= 100 && codeResp <= 104;
    const titleError: any = {
      "100": this.$t("bulkBooking.create.modalErrorRowEmpty"),
      "101": this.$t("bulkBooking.create.modalErrorDataExceed"),
      "102": this.$t("bulkBooking.create.modalErrorHeaderInvalid"),
      "103": this.$t("bulkBooking.create.modalErrorRowEmptyAlt"),
      "104": this.$t("bulkBooking.create.modalErrorQueueFull"),
      "105": this.$t("bulkBooking.create.modalErrorFileSize", {
        size: this.maximumFileSize
      }),
      default: this.$t("bulkBooking.create.modalErrorSystem")
    };

    const subtitleError: any = {
      "100": this.$t("bulkBooking.create.modalSubtitleRowEmpty"),
      "101": this.$t("bulkBooking.create.modalSubtitleDataExceed", {
        maxStt: this.maximumStt
      }),
      "102": this.$t("bulkBooking.create.modalSubtitleHeaderInvalid"),
      "103": this.$t("bulkBooking.create.modalSubtitleRowEmptyAlt"),
      "104": this.$t("bulkBooking.create.modalSubtitleQueueFull"),
      "105": this.$t("bulkBooking.create.modalSubtitleFileSize"),
      default: this.$t("bulkBooking.create.modalSubtitleSystem")
    };

    this.errorTitle = titleError[`${codeResp}`] || titleError["default"];
    this.errorSubtitle =
      subtitleError[`${codeResp}`] || subtitleError["default"];
    const btnError =
      codeResp === 105
        ? this.$t("bulkBooking.create.btnUploadAgain")
        : this.$t("bulkBooking.create.btnReload");
    this.btnModalFailed = statusCode
      ? this.$t("bulkBooking.create.btnUnderstand")
      : btnError;
    this.btnModalCancel =
      codeResp === 105 ? this.$t("bulkBooking.create.btnBack") : "";

    this.resultErrorUpload = true;
    this.errorCode = codeResp;
  }

  resetForm() {
    const reset = {
      type: "Bulk Booking",
      activityName: "",
      archiveFile: "",
      clientName: "",
      formatTemplate: ""
    };
    BulkBookingController.setFormAddBulkBooking(reset);
    BulkBookingController.setStatusClearFile(false);
  }

  closePageUploadBulkBooking() {
    this.$router.push("/shipment/bulk/bulk-v2");
  }

  onCloseUploadBulkBooking() {
    this.resultErrorUpload = false;
  }

  onSubmitFailedUploadBulkBooking() {
    this.resultErrorUpload = false;

    if (this.errorCode === 105) {
      const fileInput = document.querySelector(
        'input[type="file"]'
      ) as HTMLInputElement | null;
      fileInput?.click();
    }
  }

  get form(): any {
    return BulkBookingController.form;
  }

  get utilsBulkBooking() {
    return permissionBulkBooking;
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get internationalTemplateUrl(): string {
    return internationalTemplateUrl(
      this.dataProfile.countryCode
    );
  }

  get domesticTemplateUrl(): string {
    return this.dataProfile.countryCode?.toLowerCase() === "my"
      ? `${FlagsBcsBulkDownloadTemplate.config_bucket_storage_announcement.getValue()}/template/Template+booking+klien+-+EN.xlsx`
      : `${FlagsBcsBulkDownloadTemplate.config_bucket_storage.getValue()}/template_bulk_booking_client.xlsx`;
  }

  get maximumStt() {
    return FlagsPermissionBulkBookingV2.config_bulk_booking_v2_max_stt.getValue();
  }

  get maximumFileSize() {
    return FlagsPermissionBulkBookingV2.config_bulk_booking_v2_max_file_MB.getValue();
  }

  get isValidateType() {
    return !this.form.clientName && !this.utilsBulkBooking().permissionClient;
  }

  get isBulkUploadValid() {
    return (
      !this.form.activityName ||
      this.form.activityName.length < 3 ||
      typeof this.form.archiveFile !== "object" ||
      this.isValidateType
    );
  }

  get messageModalBookingOnProcess() {
    return this.$t("bulkBooking.create.modalOnProcess");
  }

  get templateBookingData() {
    return [
      {
        title: this.$t("bulkBooking.templates.international"),
        isButton: true,
        url: this.internationalTemplateUrl,
        permission:
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal ||
          this.utilsBulkBooking().permissionPosClient,
        id: "button_download_template_booking_klien",
        type: "",
        dataTestId:
          "bulk-booking-create-button-download-template-international"
      },
      {
        title: this.$t("bulkBooking.templates.domestic"),
        isButton: true,
        url: this.domesticTemplateUrl,
        permission:
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal ||
          this.utilsBulkBooking().permissionPosClient,
        id: "button_download_template_booking_klien",
        type: "",
        dataTestId: "bulk-booking-create-button-download-template-domestic"
      }
    ];
  }

  get templateComodityData() {
    return [
      {
        title: this.$t("bulkBooking.commodities.commodityData"),
        isButton: false,
        permission:
          this.utilsBulkBooking().permissionPos ||
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal,
        id: "field_download_data_komoditas",
        type: "commodity/export_csv",
        dataTestId: "bulk-booking-create-link-commodity-data"
      },
      {
        title: this.$t("bulkBooking.commodities.districtData"),
        isButton: false,
        permission:
          this.utilsBulkBooking().permissionPos ||
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal,
        id: "field_download_data_kecamatan",
        type: "district/export_csv?status=ACTIVE",
        dataTestId: "bulk-booking-create-link-district-data"
      }
    ];
  }

  mounted() {
    this.resetForm();
    this.form.type =
      this.utilsBulkBooking().permissionClient ||
      this.utilsBulkBooking().permissionInternal
        ? "client"
        : "";
  }
}
